// Sidebar Routers
// Sidebar Routers

export const menuItemKeys = {
  STORE: 'Store',
  PRODUCT_FEED: 'Product Feed',
  ADD_AUDIENCE: 'Add Audience',
  DASHBOARD: 'Dashboard',
  WALLET: 'Wallet',
  PUBLISHED_REPORTS: 'Reports',
  PRODUCT_INSIGHTS: 'Product Insights',
  LEADS: 'Leads'
}

export const settingsMenu = [
  {
    action: 'store_mall_directory',
    title: 'message.storeProfile',
    active: false,
    items: null,
    routeName: 'storeSetup',
    exact: true,
    key: menuItemKeys.STORE
  },
  {
    action: 'assignment',
    title: 'message.productFeed',
    active: false,
    items: null,
    routeName: 'productFeed',
    exact: true,
    key: menuItemKeys.PRODUCT_FEED
  }
]

export const featuresMenu = [
  {
    action: 'people',
    title: 'message.audience',
    active: true,
    items: null,
    routeName: 'audience',
    exact: true,
    key: menuItemKeys.ADD_AUDIENCE
  }
]

export const statsMenuItems = [
  {
    action: 'dashboard',
    title: 'message.dashboard',
    active: true,
    routeName: 'dashboard',
    exact: true,
    items: null,
    key: menuItemKeys.DASHBOARD
  },
  {
    action: 'analytics',
    title: 'message.productInsights.productInsights',
    active: true,
    routeName: 'productInsights',
    exact: true,
    items: null,
    key: menuItemKeys.PRODUCT_INSIGHTS
  },
  {
    action: 'trending_up',
    title: 'message.reports',
    active: true,
    items: null,
    routeName: 'publishedReports',
    exact: true,
    key: menuItemKeys.PUBLISHED_REPORTS
  },
  {
    action: 'assignment_ind',
    title: 'message.leadMessages.leads',
    active: true,
    items: null,
    routeName: 'leads',
    exact: true,
    key: menuItemKeys.LEADS
  }
]
export const walletMenuItem = {
  action: 'account_balance_wallet',
  title: 'message.wallet',
  active: true,
  items: null,
  routeName: 'wallet',
  exact: true,
  component: 'balance',
  key: menuItemKeys.WALLET
}